<div class="row mb-2">
  <!-- #region FORM TABS -->
  <div class="col-md-6 mt-3">
    <div [ngClass]="commonService.isTabSelected(0) ? 'selectedTab' : 'defaultTab' "
      [class.selectedTab]="commonService.isTabSelected(0)" (click)="KYCClick(); commonService.selectTab(0)">
      KYC
    </div>
  </div>
  <div class="col-md-6 mt-3">
    <div [ngClass]="commonService.isTabSelected(1) ? 'selectedTab' : 'defaultTab' "
      [class.selectedTab]="commonService.isTabSelected(1)" (click)="Landclick();commonService.selectTab(1)">
      Property
    </div>
  </div>
  <!-- #endRegion FORM TABS -->


  <!--Document Pic upload modal. For uploading document this modal will open -->
  <p-dialog [(visible)]="displayDocumentFileDialogue" [closeOnEscape]="false" [modal]="true" [draggable]="false"
    [resizable]="false" [blockScroll]=false [style]="{ width: '30rem' }" (onHide)="receiveCurrentUploadedFile($event)">
    <p-header>
      Upload {{ documentFileData?.picFor }} Pic
    </p-header>
    <app-document-file [fileDataConfig]='documentFileData'
      (documentFile)="receiveCurrentUploadedFile($event)"></app-document-file>
  </p-dialog>
  <!-- Document Pic upload modal ends here. -->

  <!--Document Large View Pic modal -->
  <app-picview *ngIf="showclickedPic" (closePicDialogue)="hidePicViewModal()" [closeOnEscape]="false"
    [picData]="picViewData"></app-picview>
</div>


<!-- KYC panel starts here -->
<div *ngIf="showKycPanel">
  <!-- Aadhaar Card Block starts here-->
  <div class="document-block mt-2">
    <div class="headtext">
      <div class="document d-flex">
        <strong>Aadhaar Card</strong>
      </div>
      <div class="document-icon text-end">
        <img src="../../../assets/images/printicon.svg">&nbsp;
        <img src="../../../assets/images/DownloadIcon.svg">&nbsp;
        <img src="../../../assets/images/document hide icon.svg" (click)="toggleAdharcard()"> &nbsp;
        <img src="../../../assets/images/zoom Icon.svg"
          (click)="zoomContent([aadharFrontDefaultPic,aadharBackdefaultPic],'Aadhar Card')">
      </div>
    </div>
    <div class="row content" id="hide" style="padding: 15px;" *ngIf="!adharHidden" style="padding: 15px;
    display: flex;
    justify-content: space-evenly;">
      <span class="col-sm-5">
        <div class="text-center">
          <div class="defaultPic">
            <img src="{{aadharFrontDefaultPic}}" id="myImg" class="rounded-3">
          </div>
          <div class="Approvedicon">
            <img src="../../../assets/images/Document Approved icon.svg" width="21" height="21" *ngIf="appaadhaarIcon">
            <img src="../../../assets/images/verify icon.svg" width="21" height="21" *ngIf="veriaadhaarIcon">
          </div>
          <div class="documentOperationIcon">
            <img src="{{ userKYCAddharFrontPicIcon }}" height="20" width="20" id="myImg"
              (click)="setCurrentFileConfig('AadhaarFront')">
          </div>
        </div>
      </span>


      <!-- Aadhaar Front Image -->
      <span class="col-sm-5">
        <!-- Aadhaar Back Image -->
        <div class="text-center">
          <div class="defaultPic">
            <img src="{{aadharBackdefaultPic}}" id="myImg" class="rounded-3 ">
          </div>
          <div class="documentOperationIcon">
            <img src="{{ userKYCAddharBackPicIcon }}" height="20" width="20"
              (click)="setCurrentFileConfig('AadhaarBack')">
          </div>
        </div>
      </span>
    </div>
  </div>
  <!-- Aadhaar Card Block Ends here-->


  <!-- Pan Card Block starts here-->
  <div class="document-block">
    <div class="headtext">
      <div class="document d-flex">
        <strong>Pan Card</strong>
      </div>
      <div class="document-icon text-end">
        <img src="../../../assets/images/printicon.svg">&nbsp;
        <img src="../../../assets/images/DownloadIcon.svg">&nbsp;
        <img src="../../../assets/images/document hide icon.svg" (click)="togglePancard()"> &nbsp;
        <img src="../../../assets/images/zoom Icon.svg" (click)="zoomContent([panDefaultPic], 'Pan Card')">
      </div>
    </div>

    <div class="row" style="padding: 15px;" *ngIf="!panHidden">
      <span class="col-sm-12">
        <div class="text-center">
          <div class="defaultPic">
            <img src="{{panDefaultPic}}" class="rounded-4" style="border: 1px solid black;">
          </div>
          <div class="Approvedicon">
            <img src="../../../assets/images/Document Approved icon.svg" width="20" height="20" *ngIf="appPanIcon">
            <img src="../../../assets/images/verify icon.svg" width="20" height="20" *ngIf="veriPanIcon">
          </div>
          <div class="documentOperationIcon">
            <img src="{{userKYCPanPicIcon}}" height="20" width="20" (click)="setCurrentFileConfig('Pan')">
          </div>
        </div>
      </span>
    </div>
  </div>
  <!-- Pan Card Block ends here-->

  <!-- Address Proof Block starts here-->
  <div class="document-block">
    <div class="headtext">
      <div class="text-start" data-bs-toggle="dropdown" aria-expanded="false"
        style="width:0px;margin-bottom: 1px;cursor:pointer;">
        <img src="../../../assets/images/Toggle icon.svg" class="rotate" (click)="toggleAnimation()"
          style="width: 30px;">
        <ul class="dropdown-menu">
          <li><a class="dropdown-item">Passport</a></li>
          <li><a class="dropdown-item">Voter ID Card</a></li>
          <li><a class="dropdown-item">Driving License</a></li>
        </ul>
      </div>
      <div class="document d-flex" style="margin-top: -30px;">
        <strong>Address Proof</strong>
      </div>
      <div class="document-icon text-end">
        <img src="../../../assets/images/printicon.svg">&nbsp;
        <img src="../../../assets/images/DownloadIcon.svg">&nbsp;
        <img src="../../../assets/images/document hide icon.svg" (click)="toggleAddress()"> &nbsp;
        <img src="../../../assets/images/zoom Icon.svg"
          (click)="zoomContent([addressDefaultPic,addressDefaultPicBack], 'Address Proof')">
      </div>
    </div>


    <div class="row content Addressadjust" id="hide" style="padding: 15px; display: flex;
    justify-content: space-evenly; margin-left: -45px;
    margin-right: 5px;" *ngIf="!addressHidden">
      <span class="col-sm-5">
        <div class="text-center">
          <div class="defaultPic">
            <img src="{{addressDefaultPic }}" id="myImg" class="rounded-3">
          </div>
          <div class="Approvedicon">
            <img src="../../../assets/images/Document Approved icon.svg" width="20" height="20" *ngIf="appaadhaarIcon">
            <img src="../../../assets/images/verify icon.svg" width="20" height="20" *ngIf="veriaadhaarIcon">
          </div>
          <div class="documentOperationIcon">
            <img src="{{ userKYCAddressFrontPicIcon }}" height="20" width="20" id="myImg"
              (click)="setCurrentFileConfig('VoterIdFront')">
          </div>
        </div>
      </span>

      <!-- Aadhaar Front Image -->
      <span class="col-sm-5">
        <!-- Aadhaar Back Image -->
        <div class="text-center">
          <div class="defaultPic">
            <img src="{{addressDefaultPicBack}}" id="myImg" class="rounded-3">
          </div>
          <div class="documentOperationIcon">
            <img src="{{ userKYCAddressBackPicIcon }}" height="20" width="20"
              (click)="setCurrentFileConfig('VoterIdBack')">
          </div>
        </div>
      </span>
    </div>
  </div>
  <!-- Address Proof Block starts here-->

  <!-- Bank Account Block starts here-->
  <div class="document-block">
    <div class="headtext">
      <div class="document d-flex">
        <strong>Cheque/Bank Passbook</strong>
      </div>
      <div class="document-icon text-end">
        <img src="../../../assets/images/printicon.svg">&nbsp;
        <img src="../../../assets/images/DownloadIcon.svg">&nbsp;
        <img src="../../../assets/images/document hide icon.svg" (click)="toggleBankPassbook()"> &nbsp;
        <img src="../../../assets/images/zoom Icon.svg" (click)="zoomContent(chequeDefaultPic,'Bank Proof')">
      </div>
    </div>
    <div class="row" style="padding: 15px; display: flex;" *ngIf="!bankHidden">
      <span class="col-sm-12">
        <div class="col-sm-12 text-center">
          <div class="pandefaultPic" style="margin-left: 65px; width:850px; height:350px">
            <img src=" {{chequeDefaultPic}}" class="rounded-3" width="min-content" width="850px" height="350px">
          </div>
          <div class="bankApprovedicon">
            <img src="../../../assets/images/Document Approved icon.svg" width="20" height="20">
            <img src="../../../assets/images/verify icon.svg" width="20" height="20" *ngIf="veriaadhaarIcon">
          </div>
          <div class="bankdocumentOperationIcon">
            <img src="{{ userKYCBankPicIcon }}" height="20" width="20" (click)="setCurrentFileConfig('BankAccount')">
          </div>
        </div>
      </span>
    </div>
    <!-- Bank Account Block starts here-->


  </div>
  <!-- KYC panel ends here -->

  <div class="row">
    <div class="col-md-12">
      <div class=" d-flex" style="justify-content: flex-end;">
        <div class="export" data-toggle="modal" data-target="#bookingModalRight">
          <div class="add-actionbutton-icon">
            <img src="assets/images/DownloadIcon.svg" aria-hidden="true">
          </div>
          <div class="add-actionbutton-text ">Download All</div>
        </div>



        <div class="export ml-2">
          <div class="export-actionbutton-icon">
            <img src="assets/images/printicon.svg" style="height: 15px;">
          </div>
          <div class="export-actionbutton-text">
            <span>Print All</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showLandPanel">
  <app-documents [docEntityData]="userData" [showIsVerified]="userData?.showIsVerified"></app-documents>
</div>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>